export default "<div *ngIf=\"stock\" style=\"width: 100%; height: 90%; display: block\" [chart]=\"stock\"></div>"